<template>
    <div class="horizontalItem">
        <div class="imgBox">
            <van-image :src="rowData.goods_pic" :height="120" :width="120" :radius="8" fit="cover">
                <template v-slot:loading>
                    <van-loading type="spinner" size="20" />
                </template>
                <template v-slot:error><van-image src="img/error.png" /></template>
            </van-image>
            <span><i>{{ $t('highEnd') }}</i></span>
        </div>
        <div style="width: calc(100% - 140px);">
            <div class="top">
                <div>
                    <van-image width="13" src="img/vip.png" />
                    <span>{{ $t('authentication') }}</span>
                </div>
                <div>
                    <van-image width="13" src="img/vip.png" />
                    <span>{{ $t('videoAuthentication') }}</span>
                </div>
                <div style="width: 70px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
                    {{ rowData.goods_name || '' }}
                </div>
            </div>
            <div class="tags" v-show="rowData.flag">
                <van-tag size="large" plain v-for="(v, i) in (rowData.flag || '').split(',')" :key="i">{{ v }}</van-tag>
            </div>
            <div style="display: flex; align-items: center;">
                <span style="font-size: 14px; color: #000000;">{{ $t('tollRange') }}：</span>
                <van-rate v-model="rowData.rate" :size="18" color="#795548" void-icon="star" void-color="#eee" />
            </div>
            <div style="color: #323233;font-size: 12px; margin: 5px 0;">
                {{ $t('personHeight') }}: {{ rowData.shop_name }}cm {{ $t('bust') }}：{{ rowData.goods_price }} {{
                    $t('serviceCity')
                }}：{{ LangData[$i18n.locale] }}
                {{
                    $t('nationalAirborne') }}：{{ $t('yse') }}
            </div>
            <div class="yueta" @click="profile">{{ $t('askHerOut') }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "horizontalItem",
    props: {
        rowData: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {}
    },
    methods: {
        profile() {
            this.$router.push({
                path: '/profile?id=' + this.rowData.id
            });
        },
    }
}
</script>

<style lang="less" scoped>
.horizontalItem {
    display: flex;
    border-bottom: 1px solid #c8c9cc;
    padding: 20px 0 30px;

    .imgBox {
        position: relative;
        overflow: hidden;
        border-radius: 8px;
        margin-right: 20px;

        >span {
            position: absolute;
            z-index: 9;
            background-color: #000000;
            color: #fff;
            transform: rotate(45deg);
            width: 150px;
            height: 150px;
            top: -80px;
            right: -80px;

            >i {
                position: absolute;
                bottom: 5px;
                left: 50%;
                transform: translateX(-50%);
                font-weight: bold;
                font-size: 28px;
            }
        }
    }

    .top {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 5px;

        >div:nth-child(1),
        >div:nth-child(2) {
            background: linear-gradient(90deg, #000000, #323233);
            color: #e8b891;
            font-weight: 600;
            font-size: 24px;
            padding: 3px;
            margin-right: 10px;
        }

        >div:last-child {
            // margin-left: 30px;
            font-size: 28px;
        }
    }

    .tags {
        display: flex;
        flex-wrap: wrap;

        >.van-tag {
            padding: 5px;
            font-size: 24px;
            margin: 0 5px 5px 0;
            border-radius: 8px;
            color: #000000;
            font-weight: bold;
        }
    }

    .yueta {
        background: linear-gradient(90deg, #323233, #000000);
        color: #fff;
        border-radius: 8px;
        padding: 10px 0;
        // width: 90%;
        // margin: 0.33333rem 0 0.66667rem;
        text-align: center;
        font-size: 26px;
    }
}
</style>